import { useParams } from 'react-router-dom'
import { doc, getDoc, updateDoc, setDoc, increment } from 'firebase/firestore'
import { db } from '../../lib/firebase'
import React, { useEffect, useState, useRef } from 'react'
import fm from 'front-matter'
import ReactMarkdown from 'react-markdown'
import postP from './PostPage.module.css'
import { FlightBar } from '../../components/flightbar/FlightBar'
import { sampleFlight } from '../../data/flights'
import { InstagramLogo, Envelope, LinkedinLogo, BehanceLogo, /*ShoppingCart,*/ PersonSimpleRun, Bicycle, Waves, PinterestLogo } from 'phosphor-react'
import { LineVerticalIcon, PaypalLogoIcon } from '@phosphor-icons/react'
import remarkGfm from 'remark-gfm';
import remarkEmoji from 'remark-emoji'

// function extractHeadings(markdown) {
//   const lines = markdown.split('\n');
//   const headings = lines
//     .filter(line => /^#{1,6}\s/.test(line))
//     .map(line => {
//       const level = line.match(/^#+/)[0].length;
//       const text = line.replace(/^#+\s*/, '').trim();
//       const slug = text.toLowerCase().replace(/[^\w]+/g, '-');
//       return { level, text, slug };
//     });

//   return nestHeadings(headings);
// }

// function nestHeadings(headings) {
//   const root = [];
//   const stack = [];

//   for (const heading of headings) {
//     const node = { ...heading, children: [] };
//     while (stack.length > 0 && stack[stack.length - 1].level >= heading.level) {
//       stack.pop();
//     }

//     if (stack.length === 0) {
//       root.push(node);
//     } else {
//       stack[stack.length - 1].children.push(node);
//     }

//     stack.push(node);
//   }

//   return root;
// }

// function TocItem({ item }) {
//   return (
//     <details className={postP.tocDetail}>
//       <summary><a href={`#${item.slug}`}>{item.text}</a></summary>
//       {item.children?.length > 0 && (
//         <div className={postP.tocChildren}>
//           {item.children.map((child, i) => (
//             <TocItem key={i} item={child} />
//           ))}
//         </div>
//       )}
//     </details>
//   );
// }

export default function PostPage({ tags }) {
    const { slug } = useParams()
    const [post, setPost] = useState({ attributes: {}, body: '' })
    const [views, setViews] = useState(0)
    const hasRun = useRef(false)
    // const [toc, setToc] = useState([]);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    const postRef = doc(db, "views", slug);

    const incrementViews = async () => {
      const docSnap = await getDoc(postRef);

      if (!docSnap.exists()) {
        // Create doc with views: 0 first (allowed by rules)
        await setDoc(postRef, { views: 0 });
      }

      // Now increment views by 1 (allowed by rules)
      await updateDoc(postRef, { views: increment(1) });
    };

    const fetchViews = async () => {
      const snap = await getDoc(postRef);
      if (snap.exists()) {
        setViews(snap.data().views);
      }
    };

    (async () => {
      await incrementViews();
      await fetchViews();
    })();
  }, [slug]);
    
//     useEffect(() => {
//         if (hasRun.current) return
//         hasRun.current = true

//         const blogRef = doc(db, "views", slug)
        
//         const incrementViews = async () => {
//             await updateDoc(blogRef, { views: increment(1) });
//         }
        
//         const fetchViews = async () => {
//             const snap = await getDoc(blogRef)
//             if (snap.exists()) {
//                 setViews(snap.data().views)
//             }
//         }
        
//         ;(async () => {
//             await incrementViews()
//             await fetchViews()
//         })()
//     }, [slug])

    useEffect(() => {
        fetch(`/posts/${slug}.md`)
        .then((res) => res.text())
        .then((text) => {
            const { attributes, body } = fm(text);
            setPost({ attributes, body });
            // setToc(extractHeadings(body));
        });
    }, [slug]);

    return (
        <main className={postP.postPage}>
            <div className={postP.header}>
                <FlightBar flight={sampleFlight} />
                <div className={postP.description}>
                    <div className={postP.info}>
                        <div className={postP.tags}>
                            {post?.attributes?.tags?.map((tags, index) => (
                                <span key={index} className={postP.tag}>
                                {tags}
                                </span>
                            ))}
                        </div>
                        <h1>{post.attributes.title}</h1>
                    </div>
                    <div className={postP.addInfo}>
                        <img src="/assets/blog/pfp.jpg" alt="pfp" loading="lazy"/>
                        <div className={postP.authStuff}>
                            <p>{post.attributes.author}</p>
                            <p>/</p>
                            <p>{post.attributes.date}</p>
                            <p>/</p>
                            <p>{views.toLocaleString()}&nbsp; views</p>
                        </div>
                    </div>
                </div>
                <div className={postP.stuff}>
                    <img src={post.attributes.coverImage} alt="" loading="lazy"/>
                    <div className={postP.myself}>
                        <div className={postP.profiles}>
                            <h1>Professional Me</h1>
                            <div className={postP.socials}>
                                <a href="mailto:kiansegantini@gmail.com" target="_blank" rel="noreferrer">
                                    <Envelope weight='light' className={postP.social} />
                                </a>
                                <a href="https://linkedin.com/in/kian-segantini" target="_blank" rel="noreferrer">
                                    <LinkedinLogo weight='light' className={postP.social} />
                                </a>
                                <a href="https://www.behance.net/kiansegantini" target="_blank" rel="noreferrer">
                                    <BehanceLogo weight='light' className={postP.social} />
                                </a>
                                <a href="https://paypal.me/" target="_blank" rel="noreferrer">
                                    <PaypalLogoIcon weight='light' className={postP.social} />
                                </a>
                                {/* <a href="https://kians-lab.printify.me/" target="_blank" rel="noreferrer">
                                    <ShoppingCart weight='light' className={postP.social} />
                                </a> */}
                            </div>
                        </div>
                        <div className={postP.profiles}>
                            <h1>Me</h1>
                            <div className={postP.all}>
                                <div className={postP.socials}>
                                    <a href="https://www.instagram.com/builtbykian/" target="_blank" rel="noreferrer">
                                        <InstagramLogo weight='light' className={postP.social} />
                                    </a>
                                    <a href="https://www.pinterest.com/kian_193/" target="_blank" rel="noreferrer">
                                        <PinterestLogo weight='light' className={postP.social} />
                                    </a>
                                </div>
                                <LineVerticalIcon weight='light' className={postP.social}/>
                                <div className={postP.socials}>
                                    <PersonSimpleRun weight='light' className={postP.social}/>
                                    <Bicycle weight='light' className={postP.social}/>
                                    <Waves weight='light' className={postP.social}/>
                                </div>
                            </div>
                        </div>
                        <div className={postP.goal}>
                            <h1>GOAL</h1>
                            <h2>$60/$13k</h2>
                        </div>
                    </div>
                </div>
                <div className={postP.bg}></div>
            </div>
            {/* <div className={postP.tocBox}>
                {toc.map((item, i) => <TocItem key={i} item={item} />)}
            </div> */}
            <article>
                <ReactMarkdown remarkPlugins={[remarkGfm, remarkEmoji]} breaks>{post.body}</ReactMarkdown>
            </article>
      </main>
    );
}